var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5092 12.3008H0.516602V13.879H15.5092V12.3008Z",
    fill: "#3B4858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9592 4.91095C15.7896 4.27968 15.1425 3.90487 14.5113 4.07452L10.3173 5.19895L4.87258 0.121216L3.34965 0.531524L6.61647 6.19319L2.69472 7.24268L1.14418 6.02353L0 6.33131L1.43614 8.82088L2.03979 9.8664L3.30628 9.52709L7.50027 8.40263L10.9288 7.48336L15.1228 6.3589C15.754 6.18925 16.1289 5.54223 15.9592 4.91095Z",
    fill: "#3B4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.9664f67ad70c5b132432f3819c9f92a8.svg";
export { ForwardRef as ReactComponent };